import { useState, useCallback } from 'react';
import { BooleanKeys, NumberKeys } from '@types';
import { ImageState } from '../model/types';

export const useImageState = (initialState: ImageState) => {
  const [imageState, setImageState] = useState<ImageState>(initialState);

  const handleToggleModeValue = useCallback((mode: BooleanKeys<ImageState>) => {
    setImageState((prevState) => ({
      ...prevState,
      [mode]: !prevState?.[mode],
    }));
  }, []);

  const handleChangeModeValue = useCallback(
    (mode: NumberKeys<ImageState>, value: number) => {
      setImageState((prevState) => ({
        ...prevState,
        [mode]: value,
      }));
    },
    []
  );

  return {
    imageState,
    handleToggleModeValue,
    handleChangeModeValue,
  };
}; 